// import {defaultContentFont, defaultContentHeaderFont, defaultMainHeaderFont, whiteColor, grayColor, blueColor, DodgerBlueColor} from '../../cmsMainStyle'

const documentSubmissionStyle = theme => ({
	// headerFont: defaultMainHeaderFont,
	// contentFont: defaultContentFont,
	// contentHeaderFont: defaultContentHeaderFont,

	root: {
		flexGrow: 1,
		backgroundColor: theme.palette.background.paper,
	},

	// appBar: {
    //     background: DodgerBlueColor[11],
	// },
	
	userRightMsg: {
		padding: theme.spacing(3),
		color: "red",
	}
})


export default documentSubmissionStyle